const spMegaMenuProduct = document.querySelector('.sp-megamenu__item-product');
const spMegaMenuProductContent = document.querySelector('#g-nav-sp');
spMegaMenuProduct.addEventListener('click', function () {
  spMegaMenuProduct.classList.toggle('active');
  spMegaMenuProductContent.classList.toggle('panelactive');
});

document.addEventListener('click', function (event) {
  if (!spMegaMenuProduct.contains(event.target) && !spMegaMenuProductContent.contains(event.target)) {
    if (spMegaMenuProduct.classList.contains('active')) {
      spMegaMenuProduct.classList.remove('active');
      spMegaMenuProductContent.classList.remove('panelactive');
    }
  }
});

const spMegaMenuProductGift = document.querySelector('.sp-megamenu__item-product-gift');
const spMegaMenuProductContentGift = document.querySelector('#g-nav-sp-gift');

const spMegaMenuItem = document.querySelector('.sp-megamenu__item-item');
const spMegaMenuItemContent = document.querySelector('#g-nav-sp-item');

spMegaMenuProductGift.addEventListener('click', function () {
  spMegaMenuProductGift.classList.toggle('active');
  spMegaMenuProductContentGift.classList.toggle('panelactive');
});

document.addEventListener('click', function (event) {
  if (!spMegaMenuProductGift.contains(event.target) && !spMegaMenuProductContentGift.contains(event.target)) {
    if (spMegaMenuProductGift.classList.contains('active')) {
      spMegaMenuProductGift.classList.remove('active');
      spMegaMenuProductContentGift.classList.remove('panelactive');
    }
  }
});

spMegaMenuItem.addEventListener('click', function () {
  spMegaMenuItem.classList.toggle('active');
  spMegaMenuItemContent.classList.toggle('panelactive');
});

document.addEventListener('click', function (event) {
  if (!spMegaMenuItem.contains(event.target) && !spMegaMenuItemContent.contains(event.target)) {
    if (spMegaMenuItem.classList.contains('active')) {
      spMegaMenuItem.classList.remove('active');
      spMegaMenuItemContent.classList.remove('panelactive');
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var megamenu = document.querySelector('.js-sp-megamenu-hidden');
  var lastScrollTop = 0;

  if (megamenu) {
    window.addEventListener('scroll', function () {
      var currentScrollTop = window.scrollY || document.documentElement.scrollTop;
      if (currentScrollTop > lastScrollTop) {
        megamenu.classList.add('active');
      } else {
        megamenu.classList.remove('active');
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  let initialScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (initialScrollTop !== 0) {
    document.querySelector('.sp-megamenu--top').style.top = '95px';
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const headerElement = document.querySelector('.sp-megamenu--top');
  const mainElement = document.querySelector('main');

  if (headerElement && mainElement) {
    const initialHeight = headerElement.offsetHeight;
    mainElement.style.setProperty('padding-top', initialHeight + 'px', 'important');

    window.addEventListener('scroll', function () {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        mainElement.style.setProperty('padding-top', '0px', 'important');
      } else {
        mainElement.style.setProperty('padding-top', initialHeight + 'px', 'important');
      }
    });
  }
});
